import {SyntheticEvent} from 'react';
import {onEmitClickEvent} from '@/lib/utils/analytics';
import {AnalyticEventProps, AnalyticsProps} from '@/types';
import {ButtonFieldsFragment, EdsButtonVariant, EdsSize} from '@common/hygraph-schema';
import {ButtonProps as EdsButtonProps, Button as EdsButton, Link} from '@eds-web/react';
import {getEdsIcon} from '@/lib/utils/edsIcon.utils';

const emitEvent = (
	event: SyntheticEvent<HTMLElement> | Event | null | undefined,
	analyticsProps?: AnalyticEventProps
) => {
	onEmitClickEvent({
		eventCategory: 'button',
		interactionType: 'click',
		...analyticsProps
	})(event);
};

type ButtonProps = ButtonFieldsFragment &
	AnalyticsProps &
	Omit<EdsButtonProps, 'size' | 'icon' | 'iconPosition'>;

export const Button = ({
	__typename,
	ukey,
	size,
	btnLabel,
	btnHref,
	btnVariant,
	icon,
	iconPosition,
	analytics,
	onClick,
	...edsProps
}: ButtonProps) => {
	const btnProps: Partial<EdsButtonProps> = {
		...edsProps,
		size: size ?? EdsSize.Md,
		variant: btnVariant ?? EdsButtonVariant.Cta,
		icon: getEdsIcon(icon),
		iconPosition: iconPosition ?? undefined,
		children: btnLabel,
		onClick: (e) => {
			emitEvent(e, {
				...analytics,
				eventValue: {
					...analytics?.eventValue,
					status: 'initiate'
				}
			});
			onClick?.(e);
		}
	};

	if (typeof btnHref === 'string' && btnHref) {
		return <EdsButton key={ukey} {...btnProps} as={Link} href={btnHref} />;
	}

	return <EdsButton key={ukey} {...btnProps} />;
};
